const mediaItems = [
  {
    title: '红桃视频 · 夏日记忆',
    duration: '48:22',
    views: '12.5万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20crimson%20and%20rose%20gradient%20composition%20with%20soft%20geometric%20shapes%20and%20light%20streaks%20on%20dark%20atmosphere%2C%20cinematic%20film%20vibe%2C%20luxury%20red%20tones%2C%20minimalist%20digital%20art&width=720&height=480&seq=media-heart&orientation=landscape'
  },
  {
    title: '小蓝视频 · 经典重现',
    duration: '36:15',
    views: '9.8万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20moody%20deep%20indigo%20and%20teal%20gradient%20with%20flowing%20geometric%20waves%20and%20soft%20bright%20highlights%20on%20dark%20surface%2C%20cinematic%20digital%20art%2C%20atmospheric%20minimalist%20composition&width=720&height=480&seq=media-blue&orientation=landscape'
  },
  {
    title: '黑桃视频 · 深夜剧场',
    duration: '52:08',
    views: '8.3万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20charcoal%20and%20onyx%20gradient%20with%20subtle%20crimson%20rim%20light%20and%20geometric%20angular%20shapes%2C%20dramatic%20cinematic%20atmosphere%2C%20minimalist%20luxury%20digital%20composition&width=720&height=480&seq=media-spade&orientation=landscape'
  },
  {
    title: '91视频 · 都市物语',
    duration: '41:50',
    views: '15.2万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20copper%20gradient%20with%20glowing%20geometric%20rectangles%20and%20light%20rays%20on%20dark%20minimalist%20background%2C%20cinematic%20mood%2C%20luxury%20urban%20digital%20art&width=720&height=480&seq=media-91&orientation=landscape'
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="relative py-14 md:py-20 bg-background-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-primary-400 font-medium tracking-wider uppercase mb-2">Featured</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">精选推荐</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">妖精视频本周数字颜色系列编辑精选内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group relative bg-background-800/40 rounded-lg overflow-hidden border border-background-700/30 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video bg-background-700/40 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/80 backdrop-blur-sm text-foreground-50 group-hover:bg-primary-500 transition-colors duration-300">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 text-xs text-foreground-300 bg-background-950/70 px-2 py-1 rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-200 group-hover:text-foreground-50 transition-colors duration-200 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 mt-1 flex items-center gap-1">
                  <i className="ri-eye-line text-[10px]"></i>
                  {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}